var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bid_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0A4.3,4.3,0,0,0,3.2,4.3a2.26,2.26,0,0,0,0,.26,4.32,4.32,0,0,0,.85,2.31,4.23,4.23,0,0,0,.84.85,4.23,4.23,0,0,1,1,.88c.71,1,.5,2.32.5,3.48v1.61A1.13,1.13,0,0,0,7.5,15a1.09,1.09,0,0,0,.92-.47,1.63,1.63,0,0,0,.22-1.06v-2.8A3.6,3.6,0,0,1,8.93,9a3,3,0,0,1,.64-.85c.27-.24.59-.4.85-.64a4.74,4.74,0,0,0,.73-.89A4.3,4.3,0,0,0,7.5,0ZM6.85,6.68,4.65,4.47l.87-.85L6.81,4.91,9.48,2.29l.87.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBid);
export default __webpack_public_path__ + "static/media/bid.3abdae1947c6c5f175006f51b48bff2e.svg";
export { ForwardRef as ReactComponent };